import { useDeleteDraftDialogContext } from "src/components/Drafts";
import { useChangesNavigation } from "../hooks";
import { ChangeRequestComputedStatusEnum } from "../types";
import { PropsType } from "./types";
import React from "react";

export const useChangesContextMenu = ({
  row,
  onDeleteDraftConfirmed,
}: PropsType) => {
  const { handleOnClick: handleOnClickView } = useChangesNavigation(row);

  const showDeleteDraftEntrance =
    row.requestStatus === ChangeRequestComputedStatusEnum.DRAFT;

  const { openDialog: openDeleteDraftDialog } = useDeleteDraftDialogContext();

  const handleOnClickDelete = React.useCallback(() => {
    openDeleteDraftDialog({
      onDeleteDraft: onDeleteDraftConfirmed,
    });
  }, [openDeleteDraftDialog, onDeleteDraftConfirmed]);

  return {
    handleOnClickView,
    handleOnClickDelete,
    showDeleteDraftEntrance,
  };
};
